// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"57f6889a","453":"9a21a21e"}[chunkId] + ".chunk.js";
};